import { makeJsonApiRequest } from '@base/axios.ts'

const baseUrl = '/api/v2'

const createField = ({ tableId, variant_type, name }) => {
  const requestData = {
    data: {
      type: 'fields',
      attributes: {
        variant_type,
        name,
      },
    },
  }
  return makeJsonApiRequest({
    url: `${baseUrl}/tables/${tableId}/fields`,
    method: 'post',
    data: requestData,
    requestId: `create-field-${tableId}`,
  })
}

const updateField = ({ tableId, fieldId, attributes }) => {
  const requestData = {
    data: {
      type: 'fields',
      attributes,
    },
  }
  return makeJsonApiRequest({
    url: `${baseUrl}/tables/${tableId}/fields/${fieldId}`,
    method: 'patch',
    data: requestData,
    requestId: `update-field-${tableId}-${fieldId}`,
  })
}

const deleteField = ({ tableId, fieldId }) =>
  makeJsonApiRequest({
    url: `${baseUrl}/tables/${tableId}/fields/${fieldId}`,
    method: 'delete',
    requestId: `del-field-${tableId}-${fieldId}`,
  })

export default {
  createField,
  updateField,
  deleteField,
}
